import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

// Protected layout. Renders the sidebar + the matched child route's main view.
// AuthGuard is wrapped around <Shell /> at the route level (App.tsx), so by
// the time Shell renders we know the user is at minimum 'user' role.
export function Shell() {
  return (
    <div className="flex h-screen bg-bg">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
